import {environment} from '../../../environments/environment';

export interface RutaDocumentoCitado {
  id: string;
  url: string;
  page?: number;
  soloOriginal?: boolean;
}

export function rutaDocumentoCitado(
  href: string,
  apiUrl = environment.apiUrl,
): RutaDocumentoCitado | null {
  let url: URL;
  try {
    url = new URL(href, window.location.origin);
  } catch {
    return null;
  }

  const apiOrigin = new URL(apiUrl, window.location.origin).origin;
  if (url.origin !== window.location.origin && url.origin !== apiOrigin) {
    return null;
  }

  const match = url.pathname.match(
    /^\/(?:api\/)?shared\/documentos\/([0-9a-fA-F-]+)\/descargar$/,
  );
  if (!match) {
    return null;
  }

  const pageText = url.hash.match(/^#page=([1-9]\d*)$/)?.[1];
  const page = pageText ? Number(pageText) : undefined;
  return {
    id: match[1],
    url: url.pathname,
    ...(url.searchParams.get('vista') === 'original' ? {soloOriginal: true} : {}),
    ...(page && Number.isSafeInteger(page) ? {page} : {}),
  };
}
